import script from "./LoginKeycloakCallback.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginKeycloakCallback.vue?vue&type=script&setup=true&lang=js"

import "./LoginKeycloakCallback.vue?vue&type=style&index=0&id=1b55541a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b55541a"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress});
